module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"SKU {name} :: ข้อมูลอะไหล่","tab.part_info":"ข้อมูลอะไหล่","tab.part_lots":"In Lot","tab.part_usages":"การใช้งาน"}}')
  delete Component.options._Ctor
}
